













































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import PemantauanTtvHarianStore from "@/store/modules/PemantauanTtvHarianStore";
import PemantauanTtvHarianService from "@/services/PemantauanTtvHarian";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPemantauanTtvInput extends Vue {
  @Prop() register!: number;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  expanded = false;
  saving = false;

  form = {
    tanda_vital_id: null as number | null,
    tanggal: moment().format("YYYY-MM-DD"),
    jam: moment().format("HH:mm"),
    oksigen_lpm: null as number | null,
    mobilisasi: null as string | null,
    jenis_cairan: null as string | null,
    tpm: null as number | null,
    jenis_transfusi: null as string | null,
    volume_transfusi: null as number | null,
    jumlah_makan: null as string | null,
    volume_minum: null as number | null,
    volume_bak: null as number | null,
    bab: null as string | null,
    volume_muntah: null as number | null,
    volume_drainase: null as number | null,
    iwl: null as number | null,
    balance_cairan: null as number | null,
    catatan: null as string | null
  };

  get ttvList() {
    return TandaVitalStore.list;
  }

  get ttvOptions() {
    return this.ttvList.map(item => ({
      text: `${item.waktu_periksa} — TD: ${item.sistole}/${item.diastole}, N: ${item.frekuensi_nadi}, S: ${item.suhu_badan}`,
      value: item.id
    }));
  }

  get balanceHint(): string {
    const balance = this.form.balance_cairan;
    if (balance === null || balance === undefined) return "Auto-calc: intake - output";
    if (balance > 0) return `Positif (+${balance} mL)`;
    if (balance < 0) return `Negatif (${balance} mL)`;
    return "Seimbang";
  }

  onTtvSelected(id: number | null) {
    if (id) {
      const ttv = this.ttvList.find(item => item.id === id);
      if (ttv) {
        this.form.tanggal = moment(ttv.waktu_periksa).format("YYYY-MM-DD");
        this.form.jam = moment(ttv.waktu_periksa).format("HH:mm");
      }
    }
  }

  calcBalance() {
    const intake = (this.form.volume_minum || 0);
    const output =
      (this.form.volume_bak || 0) +
      (this.form.volume_muntah || 0) +
      (this.form.volume_drainase || 0) +
      (this.form.iwl || 0);
    this.form.balance_cairan = intake - output;
  }

  async simpan() {
    const formRef = this.$refs.form as any;
    if (!formRef.validate()) return;

    this.saving = true;

    try {
      await PemantauanTtvHarianService.create({
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form
      });

      appModule.NoticeDelayAlert("Data pemantauan TTV berhasil disimpan");
      this.resetForm();
      this.$emit("saved");
    } catch (err) {
      // error sudah ditangani di service
    } finally {
      this.saving = false;
    }
  }

  resetForm() {
    this.form = {
      tanda_vital_id: null,
      tanggal: moment().format("YYYY-MM-DD"),
      jam: moment().format("HH:mm"),
      oksigen_lpm: null,
      mobilisasi: null,
      jenis_cairan: null,
      tpm: null,
      jenis_transfusi: null,
      volume_transfusi: null,
      jumlah_makan: null,
      volume_minum: null,
      volume_bak: null,
      bab: null,
      volume_muntah: null,
      volume_drainase: null,
      iwl: null,
      balance_cairan: null,
      catatan: null
    };
    const formRef = this.$refs.form as any;
    if (formRef) formRef.resetValidation();
  }
}
